"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyword = _interopRequireDefault(require("@/components/base/keyword.vue"));
var _hotel = _interopRequireDefault(require("@/mixins/hotel"));
var _default2 = require("@/views/hotel/creatProduct/default");
var _hotel2 = require("@/api/hotel");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  mixins: [_hotel.default],
  //此js存放商品的部分函数方法
  data: function data() {
    return {
      labelarr: [],
      form: {
        roomTypeId: '',
        numbers: [],
        count: 1
      },
      isdisable: false,
      title: '',
      rules: {
        roomTypeId: [{
          required: true,
          message: '请选择房间类型',
          trigger: 'change'
        }],
        numbers: [{
          required: true,
          message: '请输入房号数组',
          trigger: 'blur'
        }]
      },
      roomTypeOptions: [

        // 实际数据应从API获取
      ],
      proTypedialogVisible: false //门票新增弹窗
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['merProductClassify'])), {}, {
    roomNumbersInput: {
      get: function get() {
        return this.form.numbers.join(',');
      },
      set: function set(val) {
        this.form.numbers = val.split(',').map(function (s) {
          return s.trim();
        }).filter(function (s) {
          return s !== '';
        });
      }
    }
  }),
  mounted: function mounted() {
    this.gethotelLst();
    if (!localStorage.getItem('merProductClassify') && (0, _permission.checkPermi)(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
  },
  methods: {
    getLabelarr: function getLabelarr(attr) {
      this.form.numbers = attr;
      this.form.count = attr.length;
      console.log(this.form);
      console.log(attr);
      console.log(attr.length);
    },
    checkPermi: _permission.checkPermi,
    // 获取fangxing
    gethotelLst: function gethotelLst() {
      var _this = this;
      (0, _hotel2.hotelLstApi)({
        page: 1,
        limit: 30000
      }).then(function (res) {
        _this.roomTypeOptions = res.list;
      }).catch(function (res) {});
    },
    showEdit: function showEdit(type, row) {
      console.log('type', type);
      if (row) {
        if (type == 2) {
          this.title = '修改房间规则';
          Object.assign(this.form, JSON.parse(JSON.stringify(row)));
        } else {
          this.title = '详情';
          this.isdisable = true;
          Object.assign(this.form, JSON.parse(JSON.stringify(row)));
        }
        console.log(this.form);
      } else {
        this.title = '添加房间规则';
        // Object.assign(this.form, JSON.parse(JSON.stringify(defaultObj)))
        // this.form = JSON.parse(JSON.stringify(defaultObj));

        console.log(this.form);
      }
      this.gethotelLst();
    },
    // 保存
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs['formValidate'].validate(function (valid) {
        if (valid) {
          if (_this2.form.id) {
            (0, _hotel2.roomUpdateApi)(_this2.form).then(function (res) {
              _this2.$message.success('修改成功');
              _this2.$emit('success');
              _this2.proTypedialogVisible = false;
            });
          } else {
            (0, _hotel2.roomCreateApi)(_this2.form).then(function (res) {
              _this2.$message.success('新增成功');
              _this2.$emit('success');
              _this2.proTypedialogVisible = false;
            });
          }
          _this2.labelarr = [];
          _this2.form = {
            roomTypeId: '',
            numbers: [],
            count: 1
          };
        }
      });
    }
  }
};